export default __webpack_public_path__ + "static/media/ig.07e696db.svg";